import { useCallback } from 'react';
import LogRocket from 'logrocket';

import { useOrderDetailsSessionContext } from '../modals/order-details-modal/event-tracking/order-details-session-context';
import { ORDER_DETAILS_ACTION, ORDER_GRID_BULK_ACTION, RESHIP_SHIPMENT_ACTION } from '../../constants/analytics-events';
import { Segment } from '../../services/analytics-services/segment';

export const RESHIP_SHIPMENT_ACTIONS = {
  START: 'START',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  CLOSE: 'CLOSE',
};

const logRocketReshipEventName = 'RESHIP_SHIPMENT';
const logRocketBulkReshipEventName = 'BULK_RESHIP_SHIPMENT';

export const useTrackReshipShipmentAction = (action, fulfillmentPlanId) => {
  const { sessionId } = useOrderDetailsSessionContext();

  return useCallback(
    (data) => {
      const { error, reshipFulfillmentPlanId } = data || {};
      const trackEvent = () => {
        if (action === RESHIP_SHIPMENT_ACTIONS.START) {
          const environment = process.env.NODE_ENV || 'development';
          LogRocket.track(logRocketReshipEventName, {
            env: environment,
          });
        }
        Segment.trackEvent(RESHIP_SHIPMENT_ACTION, {
          parentAction: ORDER_DETAILS_ACTION,
          action,
          sessionId,
          originalFulfillmentPlanId: fulfillmentPlanId,
          error,
          reshipFulfillmentPlanId,
        });
      };
      setTimeout(trackEvent, 0);
    },
    [action, sessionId, fulfillmentPlanId],
  );
};

export const useTrackBulkReshipShipmentAction = (action, fulfillmentPlanIds) => {
  return useCallback(
    (data) => {
      const trackEvent = () => {
        if (action === RESHIP_SHIPMENT_ACTIONS.START) {
          const environment = process.env.NODE_ENV || 'development';
          LogRocket.track(logRocketBulkReshipEventName, {
            env: environment,
          });
        }
        Segment.trackEvent(RESHIP_SHIPMENT_ACTION, {
          parentAction: ORDER_GRID_BULK_ACTION,
          action,
          bulkFulfillmentPlanIds: fulfillmentPlanIds,
          ...data,
        });
      };
      setTimeout(trackEvent, 0);
    },
    [action, fulfillmentPlanIds],
  );
};
